<template>
  <tr v-if="config?.dock?.id">
    <td>
      {{ $e("Dock")}} :
    </td>
    <td>
      {{ DockRainWind }}
    </td>
    <td>

    </td>
  </tr>
  <tr>
    <td>
      {{ $e("Drone")}} :
    </td>
    <td>
      <div class="flex items-center">
        <svg v-if="DroneWindDirection != 0" class="fill-current w-[10px] mr-1" :class="{
          'rotate-[0deg]': 1,
          'rotate-[45deg]': DroneWindDirection == 2,
          'rotate-[90deg]': DroneWindDirection == 3,
          'rotate-[135deg]': DroneWindDirection == 4,
          'rotate-[180deg]': DroneWindDirection == 5,
          'rotate-[225deg]': DroneWindDirection == 6,
          'rotate-[270deg]': DroneWindDirection == 7,
          'rotate-[315deg]': DroneWindDirection == 8,
        }" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 46.69 56.28">
          <path
            d="M45.78,21.16s-.02-.02-.04-.04L25.57.93c-1.24-1.24-3.24-1.24-4.48,0L.91,21.12c-1.22,1.25-1.21,3.25.04,4.48,1.23,1.21,3.21,1.21,4.44,0l14.78-14.79v42.31c0,1.75,1.42,3.17,3.17,3.17s3.17-1.42,3.17-3.17V10.84l14.75,14.76c1.22,1.25,3.23,1.27,4.48.04,1.25-1.22,1.27-3.23.04-4.48Z" />
        </svg>

        {{ DroneWindSpeed }} km/h
      </div>
    </td>
    <td></td>
  </tr>
</template>
<script>
export default {
  props: {
    config: Object,
    cheack: Object,
  },

  setup() {
    return {
    }
  },

  mounted() {
  },

  computed: {
    DockRainWind() {
      let rainfall = this.config?.dock?.status?.rainfall != undefined
        ? this.config.dock?.status.rainfall
        : 0;

      let WindSpeed = this.config?.dock?.status?.wind_speed != undefined
        ? this.config.dock?.status.wind_speed
        : 0;

      let texte = "Normal";

      if (rainfall == 1) {
        texte = "Pluie légère";
      }
      else if (rainfall == 2) {
        texte = "Pluie modérée";
      }
      else if (rainfall == 3) {
        texte = "Forte pluie";
      }

      if (WindSpeed != 0) {
        texte += " & Vent : " + (WindSpeed * 3.6).toFixed(0) + " km/h";
      }

      return texte;
    },

    DroneWindSpeed() {
      return this.config?.drone?.status?.wind_speed != undefined
        ? (parseFloat(this.config.drone?.status.wind_speed) * 3.6 / 10).toFixed(1)
        : ENV.NO_DATA;
    },

    DroneWindDirection() {
      return this.config?.drone?.status?.wind_direction != undefined
        ? this.config.drone.status.wind_direction
        : 0
    }
  },
  methods: {

  },
  watch: {
  }
}
</script>
